<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="12">
      <el-simple-table :items="dataList" />
    </v-col>
  </v-row>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'DataProvider',
  components: {},
  props: {
    mandateData: [Array, Object],
  },
  computed: {
    dataList() {
      return [
        {
          title: 'Identifikavimo kodas',
          value: this.mandateData.mandate_code,
        },
        {
          title: 'Įregistravimo data',
          value: this.mandateData.registration_date,
        },
        {
          title: 'Įgaliojimo (tėvinio) identifikavimo kodas',
          value: this.mandateData.parent?.code || this.mandateData.parent?.mandate_code,
          hide: !this.mandateData.parent,
        },
        {
          title: 'Įgaliojimas, duotas perįgaliojant',
          value: ' ',
          hide: !this.mandateData.parent,
        },
        {
          title: 'Suteikiama teisė perįgalioti',
          value: this.mandateData.submandate_allowed ? 'Taip' : 'Ne',
        },
        {
          title: 'Įgaliojimo atšaukiamumas',
          value: this.mandateData.cancelable ? 'Atšaukiamas' : 'Neatšaukiamas',
        },
        {
          title: 'Terminas',
          value: Enums.terms.lt[this.mandateData.term] ?? '',
        },
        {
          title: 'Data apibrėžtas terminas',
          value: this.mandateData.term_date,
        },
      ]
    },
  },
}
</script>

<style>
</style>